import React, { useEffect, useRef } from 'react'
import { Link, usePage, useForm } from '@inertiajs/react'

import { ImFolderUpload } from 'react-icons/im'
import { IconButton, Progress } from '@material-tailwind/react'

import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TableFilter from '@/Shared/TableFilter'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import { getSerNo } from '@/utils'

const Index = () => {
  const {
    laundries,
    type,
    auth: {
      user: { role }
    }
  } = usePage().props

  const {
    data,
    meta: { links }
  } = laundries

  const ref = useRef()
  const buttonRef = useRef()

  const {
    data: formData,
    setData,
    post,
    progress,
    reset
  } = useForm({
    file: null
  })

  useEffect(() => {
    if (formData.file) {
      buttonRef.current.click()
    }
  }, [formData])

  function submit(e) {
    e.preventDefault()
    post(route('hr-upload'))
    ref.current.value = null
    reset()
  }

  return (
    <div>
      <BreadCrumbs
        link={route().current()}
        title={`Laundries`}
        subTitle="List"
      />

      <h1 className="mb-2 text-3xl font-bold">
        Laundry <span className="text-indigo-400">{type}</span>
      </h1>

      {progress && (
        <Progress
          value={progress.percentage}
          max="100"
          color="indigo"
          className="my-4"
        />
      )}

      <div className="mb-6 flex items-center justify-between">
        <div className="flex flex-row items-center gap-x-2">
          <SearchFilter />

          {role === '1' && (
            <IconButton
              size="lg"
              color="indigo"
              className="h-8"
              onClick={() => ref.current.click()}
            >
              <form onSubmit={submit} className="hidden">
                <input
                  type="file"
                  name="file"
                  accept=".xls,.xlsx"
                  ref={ref}
                  onChange={e => setData('file', e.target.files[0])}
                />

                <button type="submit" ref={buttonRef}>
                  Submit
                </button>
              </form>
              <ImFolderUpload size={20} className="cursor-pointer" />
            </IconButton>
          )}
        </div>

        <div className="flex items-center gap-x-4">
          <TableFilter exportRoute="hr.export" />

          {role === '1' ? (
            <Link
              className="btn-indigo focus:outline-none"
              href={route('laundry.create', type)}
            >
              <span>Add</span>
              <span className="hidden md:inline"> Record</span>
            </Link>
          ) : null}
        </div>
      </div>

      <div className="overflow-x-auto rounded bg-white shadow">
        <table className="w-full whitespace-nowrap">
          <thead>
            <tr className="text-left font-bold">
              <th className="px-6 pb-4 pt-5">Sr No.</th>
              <th className="px-6 pb-4 pt-5">Hospital</th>
              <th className="px-6 pb-4 pt-5">Bed Sheet</th>
              <th className="px-6 pb-4 pt-5">Blanket</th>
              <th className="px-6 pb-4 pt-5">Pillow Cover</th>
              <th className="px-6 pb-4 pt-5">Gown</th>
              <th className="px-6 pb-4 pt-5">Curtain</th>
              <th className="px-6 pb-4 pt-5">Table Cloth</th>
              <th className="px-6 pb-4 pt-5">Washroom Towels</th>
              <th className="px-6 pb-4 pt-5">Draw Sheet</th>
              <th className="px-6 pb-4 pt-5">
                OT Kit (Trouser and shirt for doctor)
              </th>
              <th className="px-6 pb-4 pt-5">OT Gown / Doctor’s Coat</th>
              <th className="px-6 pb-4 pt-5">Apron Bearers</th>
            </tr>
          </thead>
          <tbody>
            {data.map(
              (
                {
                  id,
                  hospital_name,
                  bed_sheet,
                  blanket,
                  pillow_cover,
                  gown,
                  curtain,
                  table_cloth,
                  washroom_towels,
                  draw_sheet,
                  ot_kit,
                  ot_gown,
                  apron_bearers,
                  deleted_at
                },
                index
              ) => {
                return (
                  <tr
                    key={id}
                    className="focus-within:bg-gray-100 hover:bg-gray-100"
                  >
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                          {getSerNo(links, index)}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={user.role === '1' ? route('hr.hospital', {
                        //     service: String(type).toLowerCase(),
                        //     hospital: hospital_id
                        // }) : route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {hospital_name}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                      >
                        {bed_sheet}
                        {deleted_at && (
                          <Icon
                            name="trash"
                            className="ml-2 h-3 w-3 flex-shrink-0 fill-current text-gray-400"
                          />
                        )}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={user.role === '1' ?
                        //     route('hr.package', {service: type.toLowerCase(), package: package_name})
                        //     : route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {blanket}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={user.role === '1' ? route('hr.firm', {
                        //         service: String(type).toLowerCase(),
                        //         firm
                        //     })
                        //     : route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {pillow_cover}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {gown}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {curtain}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {table_cloth}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {washroom_towels}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {draw_sheet}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {ot_kit}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {ot_gown}
                      </Link>
                    </td>
                    <td className="border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                      >
                        {apron_bearers}
                      </Link>
                    </td>
                    <td className="w-px border-t">
                      <Link
                        tabIndex="-1"
                        // href={route('hr.edit', {service: type.toLowerCase(), hr: id})}
                        className="flex items-center px-4 focus:outline-none"
                      >
                        <Icon
                          name="cheveron-right"
                          className="block h-6 w-6 fill-current text-gray-400"
                        />
                      </Link>
                    </td>
                  </tr>
                )
              }
            )}
            {data.length === 0 && (
              <tr>
                <td className="border-t px-6 py-4" colSpan="4">
                  No record found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination links={links} />
    </div>
  )
}

Index.layout = page => <Layout title="Laundry Table" children={page} />

export default Index
